<template>
  <basic-container>
    <el-form
      :model="searchForm"
      ref="searchFormRef"
      label-width="100px"
      label-suffix=":"
      v-show="searchBoxFlag"
    >
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="项目名称" prop="projectId">
            <el-select
              v-model="searchForm.projectId"
              style="width:100%"
              placeholder="项目名称"
              @change="projectIdChange"
            >
              <el-option
                v-for="item in projectList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="查看类型" prop="type">
            <el-select v-model="searchForm.type" style="width:100%" placeholder="查看类型">
              <el-option
                v-for="item in typeDice"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6"  >
          <el-form-item label="仓库名称" prop="warehouseName">
            <el-select :disabled="searchForm.type==1" v-model="searchForm.warehouseId" clearable style="width:100%" placeholder="仓库名称">
              <el-option
                v-for="item in warehouseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="物料名称" prop="consumableName">
            <el-input
              clearable
              v-model="searchForm.consumableName"
              placeholder="物料名称"
              maxlength="100"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="物料编码" prop="consumableCode">
            <el-input
              clearable
              v-model="searchForm.consumableCode"
              placeholder="物料编码"
              maxlength="100"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="规格型号" prop="specification">
            <el-input
              clearable
              v-model="searchForm.specification"
              placeholder="规格型号"
              maxlength="100"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-checkbox v-model="searchForm.upWarnFlag" false-label="false" true-label="true"
            >高于上限预警</el-checkbox
          >
          <el-checkbox v-model="searchForm.downWarnFlag" false-label="false" true-label="true"
            >低于下限预警</el-checkbox
          >
        </el-col>
        <el-col :span="6">
          <div style="float:right">
            <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
              搜索
            </el-button>
            <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      ref="crud"
      @on-load="onLoad"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @selection-change="selectionChange"
    >
      <template slot="menuRight">
        <searchFromShow
          :searchBoxFlag.sync="searchBoxFlag"
          :removeHeight="searchHeight"
          :option="option"
          reduceHeight="20"
          :refOption="$refs.crud"
        ></searchFromShow>
      </template>
      <template slot="warehouseName" slot-scope="scope">
        <div v-if="scope.row.type==1">
          总库存
        </div>
        <div v-else>
          {{ scope.row.warehouseName }}
        </div>
      </template>
      <template slot="stockNum" slot-scope="scope">
      <div v-if="validateStockNum(scope.row)">{{ scope.row.stockNum }}</div>
      <div v-else style="color: red;">{{ scope.row.stockNum }}</div>
      </template>
      <template slot="menuLeft">
        <el-button type="primary" size="small" @click="settingWarn"> 设置仓库预警值</el-button>
        <el-button v-if="permission.total_watch" type="primary" size="small" @click="settingTotalWarn">
          设置总库存预警值</el-button
        >
        <el-button type="primary" size="small" @click="importFun"> 批量导入</el-button>
        <el-button type="primary" size="small" @click="exportFun"> 导出</el-button>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button type="text" size="small" @click="editRecord(scope.row)">编辑 </el-button>

        <el-button type="text" size="small" @click="deleteFun(scope.row.id)">删除 </el-button>
      </template>
    </avue-crud>
    <hr-dialog
      title="设置仓库预警值"
      :allowFull="false"
      width="60%"
      :visible.sync="settingWarnVisible"
    >
      <template slot="body">
        <WarnSetting
        :model="formModel"
        :row="formRow"
          @cancle="recordCancle"
          v-if="settingWarnVisible"
          
          @success="recordSuccess"
          :projectId="this.searchForm.projectId"
        ></WarnSetting>
      </template>
    </hr-dialog>
    <hr-dialog
      title="设置总仓库预警值"
      :allowFull="false"
      width="60%"
      :visible.sync="settingTotalWarnVisible"
    >
      <template slot="body">
        <WarnTotalSetting
        :model="formModel"
        :row="formRow"
          @cancle="recordCancle"
          v-if="settingTotalWarnVisible"
          @success="recordSuccess"
          :projectId="this.searchForm.projectId"
        ></WarnTotalSetting>
      </template>
    </hr-dialog>
    <hr-dialog
      title="编辑仓库预警值"
      :allowFull="false"
      width="60%"
      :visible.sync="editVisible"
    >
      <template slot="body">
        <WarnSettingEdit
      
        :row="formRow"
          @cancle="recordCancle"
          v-if="editVisible"
          @success="recordSuccess"
          :projectId="this.searchForm.projectId"
        ></WarnSettingEdit>
      </template>
    </hr-dialog>
    <ImportFormVue
      :export1Api="`/api/v4ward/warehouse/stockWarn/export-template`"
      :export2Api="`/api/v4ward/warehouse/stockWarn/export-material-template`"
      :submitApi="`/api/v4ward/warehouse/stockWarn/uploadExcelMaterial`"
      :flag="permission.total_watch"
      @success="importSuccess"
      :projectId="this.searchForm.projectId"
      :visible.sync="isImportDialogShow"
    ></ImportFormVue>
  </basic-container>
</template>
<script>
import { getProjectList } from '@/api/crmedical/project/project';
import { stockWarnPage, getWarehouseList,stockWarnDelete } from './index.js';

import searchFromShow from '@/components/search-form-show/index';
import { mapGetters } from 'vuex';
import WarnSetting from './warnSetting.vue';
import exportData from '@/components/exportData/exportDataSimple';
import WarnTotalSetting from './warnTotalSetting.vue';
import ImportFormVue from './importForm.vue';
import { getToken } from '@/util/auth';
import WarnSettingEdit from './warnSettingEdit.vue';
export default {
  components: { searchFromShow, WarnSetting, ImportFormVue, WarnTotalSetting, exportData,WarnSettingEdit },
  data() {
    return {
      editVisible:false,
      formModel:'add',
      isImportDialogShow: false,
      settingTotalWarnVisible: false,
      settingWarnVisible: false,
      printVisible: false,
      addOrderVisible: false,
      alarmRuleVisible: false,
      alarmRuleTittle: '编辑',
      alarmRuleModel: 'view',
      rowInfo: {},
      searchForm: {
        projectId: '',
        warehouseId: '',
        type: '0',
        consumableCode: '',
        consumableName: '',
        specification: '',
        upWarnFlag: 'false',
        downWarnFlag: 'false',
      },
      typeDice: [
        {
          dictKey: '0',
          dictValue: '按仓库',
        },
        {
          dictKey: '1',
          dictValue: '按总库存',
        },
      ],
      projectList: [],

      option: {
        selection: false,
        select: true,
        index: true,
        indexLabel: '#',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '仓库名称',
            prop: 'warehouseName',
            slot:true
          },
          {
            label: '物料类型',
            prop: 'consumableName',
          },
          {
            label: '物料编码',
            prop: 'consumableCode',
          },
          {
            label: '物料名称',
            prop: 'consumableName',
          },
          {
            label: '规格型号',
            prop: 'specification',
          },
          {
            label: '计量单位',
            prop: `measuringUnitName`,
          },
          {
            label: '上限预警 ',
            prop: 'upWarnValue',
          },
          {
            label: '下限预警 ',
            prop: 'downWarnValue',
          },

          {
            label: '仓库余量',
            slot:true,
            prop: 'stockNum',
          },
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
      searchBoxFlag: true,
      searchHeight: '',
      selectionList: [],
      recordIds: [],
      canteenList: [],
      warehouseList: [],
      selectionIds: '',formRow:{}
    };
  },
  created() {
    if(this.permission.total_watch){
      this. typeDice= [
        {
          dictKey: '0',
          dictValue: '按仓库',
        },
        {
          dictKey: '1',
          dictValue: '按总库存',
        },
      ]
    }else{
      this. typeDice= [
        {
          dictKey: '0',
          dictValue: '按仓库',
        }
        
      ]
    }
    this.initData();
  },
  computed: {
    ...mapGetters(['permission'])
  },
  mounted() {
    this.calcHeight();
  },
  methods: {
    importSuccess(){
      this.isImportDialogShow = false
      this.onLoad()
    },
    validateStockNum(row){
      console.log(row.upWarnValue!=null&&row.downWarnValue!=null)
      if(row.upWarnValue!=null&&row.downWarnValue!=null){
        if(Number(row.stockNum)<=Number(row.upWarnValue)&&Number(row.stockNum)>=Number(row.downWarnValue)){
          return true
        }else{
          return false
        }
      }else{
        if(row.upWarnValue!=null&&Number(row.stockNum)<=Number(row.upWarnValue)){
          return true
        }
        if(row.downWarnValue!=null&&Number(row.stockNum)>=Number(row.downWarnValue)){
          return true
        }
        return true
        
      }
    },
    deleteFun(id){
      this.$confirm(' 是否删除该数据?', '提示', {
           confirmButtonText: '确定',
           cancelButtonText: '取消',
           type: 'warning'
         }).then(() => {
          stockWarnDelete(id).then(re=>{
            this.$message.success('删除成功');
            this.onLoad()
          })
         
         }).catch(() => {
           this.$message({
             type: 'info',
             message: '已取消操作'
           });          
         });
     
    },
    exportFun() {
      let params = this.tool.formateObjToParamStr(this.searchForm);
      this.tool.downloadFile(
        `/api/v4ward/warehouse/stockWarn/exportStockWarmSetting?${
          this.website.tokenHeader
        }=${getToken()}&${params}`
      );
    },
    selectionChange(val) {
      this.selectionList = val;
      let Ids = [];
      val.forEach((element) => {
        Ids.push(element.id);
      });
      this.selectionIds = Ids.join(',');
    },
    // 数据导出
    exportExcel(data) {
      let saveIds = data.exportExcelSelectionRadio == '1' ? '' : this.selectionIds;

      if (saveIds.length == 0 && data.exportExcelSelectionRadio == 2) {
        this.$message({
          message: '请选择需要导出的数据！',
          type: 'warning',
        });
        return;
      }
      this.$confirm('是否导出综合巡查记录数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        //导出数据
        let projectId = this.exportForm.projectId;

        if (data.exportExcelSelectionRadio == 2) {
          this.tool.downloadFile(
            `/api/v4ward/personal/config/export/default/taskGeneralExport?${
              this.website.tokenHeader
            }=${getToken()}&configExport=${
              data.configExport
            }&projectId=${projectId}&exportIds=${saveIds}`
          );
        } else {
          // 将条件参数拼接为路由传参格式
          let paramFormString = this.tool.objToform(this.exportForm);
          //
          this.tool.downloadFile(
            `/api/v4ward/personal/config/export/default/taskGeneralExport?${
              this.website.tokenHeader
            }=${getToken()}&configExport=${data.configExport}&${paramFormString}`,
            'abc.xlsx',
            'xlsx/xls'
          );
        }
      });
    },
    editRecord(row){
      this.formRow = row
      this.editVisible = true;
    },
    settingTotalWarn() {
      this.formModel='add'
      this.settingTotalWarnVisible = true;
    },
    importFun() {
     
      this.isImportDialogShow = true;
    },
    settingWarn() {
      this.formModel='add'
      this.settingWarnVisible = true;
    },
   
    recordCancle() {
      this.editVisible = false
      this.settingWarnVisible = false;
      this.settingTotalWarnVisible = false;
    },
    recordSuccess() {
      this.editVisible = false
      this.settingWarnVisible = false;
      this.settingTotalWarnVisible = false;
      this.onLoad();
    },
    viewRecord(row) {
      this.alarmRuleTittle = '查看';
      this.rowInfo = row;

      this.alarmRuleModel = 'view';
      this.alarmRuleVisible = true;
    },

    addRecord() {
      this.alarmRuleTittle = '新增';
      this.alarmRuleVisible = true;
      this.rowInfo = {
        projectId: this.searchForm.projectId,
      };
      this.alarmRuleModel = 'add';
    },
   
    stopCanteen() {
      this.alarmRuleVisible = true;
    },
    projectIdChange(projectId) {
    
      this.searchForm.warehouseId =''
      this.warehouseList = [];
      getWarehouseList({ projectId: this.searchForm.projectId }).then((res) => {
            this.warehouseList = res.data;
          });
      // //  getCanteenName({projectId:projectId}).then(res=>{
      // //           this.canteenList = res.data
      // //        })
      // this.getDeptList(this.searchForm.projectId);
      // this.getCanteen(this.searchForm.projectId);
    },
    searchRecord() {
      this.page.currentPage = 1;
      if(this.searchForm.upWarnFlag==""){
        this.searchForm.upWarnFlag = false
      }
      if(this.searchForm.downWarnFlag==""){
        this.searchForm.downWarnFlag = false
      }
      this.onLoad();
    },
    searchClear() {
      this.tool.clearObject(this.searchForm, 'projectId');
      this.searchForm.type='0'
    },

    calcHeight() {
      this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
      this.option.height = this.bodyHeight - this.searchHeight - 279 - 20;
    },
    initData() {
      getProjectList().then((res) => {
        this.projectList = res.data;
        if (this.projectList.length > 0) {
          this.$set(this.searchForm, 'projectId', this.projectList[0].id);
          getWarehouseList({ projectId: this.searchForm.projectId }).then((res) => {
            this.warehouseList = res.data;
          });
          this.onLoad();
        }
      });
      // getDictionary('canteen_order_status').then((res) => {
      //   this.orderStatus = res.data;
      // });
    },

    onLoad() {
      if (this.searchForm.projectId != '') {
        this.loading = true;

        stockWarnPage(
          Object.assign(
            {},
            { current: this.page.currentPage, size: this.page.pageSize },
            this.searchForm
          )
        )
          .then(({ data }) => {
            this.data = data.records;
            this.page.total = data.total;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>

<style scoped>
::v-deep .avue-crud__right {
  display: flex;
}
/deep/ .el-drawer__body {
  overflow: scroll !important;
}
::v-deep .avue-crud .el-form-item {
  display: block;
}

.money {
  text-align: right;
}
.txtOver {
  display: -webkit-box;
  overflow: hidden; /*超出隐藏*/
  text-overflow: ellipsis; /*隐藏后添加省略号*/
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
<style>
#alarmRule > div > div.el-dialog__body {
  height: calc(100% - 100px);
}
</style>
